import config from '../config';

const FRESHWORKS_WIDGET_ID = config.freshworksWidgetId;

/**
 * To load fresh works widget on UI
 * @param {HTMLElement} i ,  document of page
 * @param {String} t , id of freshworks script
 */
function loadFreshworksWidget(i, t) {
  // 1st setup freshworks object in window object
  setupFreshworksWidget();
  var e;

  // Then Create freshworks widget script and append to head tag
  ((e = i.createElement('script')).id = t),
    (e.async = true),
    (e.defer = true),
    (e.src = `https://widget.freshworks.com/widgets/${FRESHWORKS_WIDGET_ID}.js`),
    i.head.appendChild(e);
}

// To set widget settings
function setupFreshworksWidget() {
  window.fwSettings = {
    widget_id: FRESHWORKS_WIDGET_ID
  };

  !(function() {
    //eslint-disable-next-line
    if ('function' != typeof window.FreshworksWidget) {
      var n = function() {
        n.q.push(arguments);
      };
      (n.q = []), (window.FreshworksWidget = n);
    }
  })();

  const userData = JSON.parse(localStorage.getItem('userData'));

  // Setting prefilled data in contact form
  window.FreshworksWidget('identify', 'ticketForm', {
    name: userData?.name || '',
    email: userData?.email || ''
  });
}

export function initFreshworksWidget(document) {
  loadFreshworksWidget(document, 'freshchat-js-sdk');
}

// To toggle widget
export function toggleFreshworksWidget(state) {
  window.FreshworksWidget(state ? 'show' : 'hide');
}
